// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d2de89f","455":"a739a5ee","977":"8f1199c3"}[chunkId] + ".chunk.js";
};